import { IS_WEB } from '../../constants/platform';

export const htmlDecode = (input: any) => {
  if (IS_WEB) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(input, 'text/html');
    return doc.body.textContent || ''; // Extract plain text
  } else {
    var plainString = input.replace(/<[^>]+>/g, '');
    return plainString;
  }
};
